var map = {
	"./icons/angle-down": 7102,
	"./icons/angle-down.svg": 7102,
	"./icons/angle-up": 1605,
	"./icons/angle-up.svg": 1605,
	"./icons/award": 4075,
	"./icons/award.svg": 4075,
	"./icons/calendar": 2546,
	"./icons/calendar.svg": 2546,
	"./icons/carot-left": 3923,
	"./icons/carot-left.svg": 3923,
	"./icons/carot-right": 2230,
	"./icons/carot-right.svg": 2230,
	"./icons/clipboard": 4250,
	"./icons/clipboard.svg": 4250,
	"./icons/close": 3796,
	"./icons/close.svg": 3796,
	"./icons/dash": 2300,
	"./icons/dash.svg": 2300,
	"./icons/download": 2400,
	"./icons/download.svg": 2400,
	"./icons/menu": 3685,
	"./icons/menu.svg": 3685,
	"./icons/pen": 7201,
	"./icons/pen.svg": 7201,
	"./icons/plus": 1296,
	"./icons/plus.svg": 1296,
	"./icons/rate": 4721,
	"./icons/rate.svg": 4721,
	"./icons/tick": 7831,
	"./icons/tick.svg": 7831,
	"./icons/user": 6449,
	"./icons/user-circle": 6686,
	"./icons/user-circle.svg": 6686,
	"./icons/user-group": 2263,
	"./icons/user-group.svg": 2263,
	"./icons/user.svg": 6449,
	"./icons/video": 7505,
	"./icons/video-outline": 7092,
	"./icons/video-outline.svg": 7092,
	"./icons/video.svg": 7505,
	"./nzsl-pas-logo": 8689,
	"./nzsl-pas-logo-email": 1741,
	"./nzsl-pas-logo-email.png": 1741,
	"./nzsl-pas-logo-white": 8981,
	"./nzsl-pas-logo-white.svg": 8981,
	"./nzsl-pas-logo.svg": 8689,
	"./video-placeholder": 1878,
	"./video-placeholder.svg": 1878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8257;